// The one moment of motion (the wave settles, the score counts up) is skipped when the device asks for less motion.
export function reducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
